var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selected-option"},[_c('span',[_vm._v(_vm._s(_vm.selectedData.name))]),(_vm.selectedData.icon != '')?_c('ImageLoader',{attrs:{"src":_vm.selectedData.icon,"name":_vm.selectedData.name}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }